module.exports = window["wp"]["blockSerializationDefaultParser"];